// Quota tracking + tier management
import { storage } from './storage';

export const TIERS = {
  free: {
    id: 'free',
    label: 'Free',
    chats: 20,
    quizzes: 2,
    flashcards: 1,
  },
  test: {
    id: 'test',
    label: 'Test Mode',
    chats: 60,
    quizzes: 5,
    flashcards: 5,
  },
  monthly: {
    id: 'monthly',
    label: 'Prime Monthly',
    chats: Infinity,
    quizzes: Infinity,
    flashcards: Infinity,
  },
};

const USAGE_KEY = 'brahmastra.usage.v1';

function today() {
  const d = new Date();
  return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
}

function readUsage() {
  const u = storage.get(USAGE_KEY, { date: today(), chats: 0, quizzes: 0, flashcards: 0 });
  if (u.date !== today()) {
    const fresh = { date: today(), chats: 0, quizzes: 0, flashcards: 0 };
    storage.set(USAGE_KEY, fresh);
    return fresh;
  }
  return u;
}

function writeUsage(u) {
  storage.set(USAGE_KEY, u);
}

export function getCurrentTier() {
  const prime = storage.get(storage.KEYS.PRIME, { active: false });
  if (!prime.active) return TIERS.free;
  // Check expiry
  if (prime.expires_at) {
    const exp = new Date(prime.expires_at).getTime();
    if (Date.now() > exp) {
      storage.set(storage.KEYS.PRIME, { active: false });
      return TIERS.free;
    }
  }
  const plan = prime.plan?.id || 'free';
  return TIERS[plan] || TIERS.free;
}

export function getUsage() {
  return readUsage();
}

export function getLimits() {
  const tier = getCurrentTier();
  const usage = readUsage();
  return {
    tier,
    usage,
    remaining: {
      chats: tier.chats === Infinity ? Infinity : Math.max(0, tier.chats - usage.chats),
      quizzes: tier.quizzes === Infinity ? Infinity : Math.max(0, tier.quizzes - usage.quizzes),
      flashcards: tier.flashcards === Infinity ? Infinity : Math.max(0, tier.flashcards - usage.flashcards),
    },
  };
}

export function canConsume(type) {
  // During dev (preview), bypass quotas so you can freely test.
  // Auto-enforces in production build (yarn build / deployed).
  if (process.env.NODE_ENV === 'development') return true;
  const { remaining } = getLimits();
  return remaining[type] === Infinity || remaining[type] > 0;
}

export function consume(type) {
  const u = readUsage();
  u[type] = (u[type] || 0) + 1;
  writeUsage(u);
  window.dispatchEvent(new Event('brahmastra:usage'));
  return u;
}

export function isDevUnlimited() {
  return process.env.NODE_ENV === 'development';
}

export function activatePrime(plan, expires_at, paymentId) {
  storage.set(storage.KEYS.PRIME, {
    active: true,
    plan,
    payment_id: paymentId,
    expires_at,
    since: Date.now(),
  });
  window.dispatchEvent(new Event('brahmastra:prime'));
}

export function getPrime() {
  return storage.get(storage.KEYS.PRIME, { active: false });
}
